export default __webpack_public_path__ + "static/media/SUPER_PAGES.ec2ae7e2.png";